class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector('#predictive-search')

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,page,article,collection,query&resources[limit_scope]=each&resources[limit]=6`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.open()

        this.enableTabToResults()
      })
      .then(() => {
        StampedFn.reloadUGC()
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.style.display = 'block'
  }

  close() {
    this.predictiveSearchResults.style.display = 'none'
  }

  enableTabToResults() {
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        const firstResult = this.predictiveSearchResults.querySelector('.predictive-search-list a');
        if (firstResult) {
          e.preventDefault();
          firstResult.focus();
        }
      }
    }, { once: true }); // only attach this once per result render
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define('predictive-search', PredictiveSearch)
